import { TabItem } from '@components-common/layouts';
import { addIndex, map } from 'ramda';

const createPath = (basePath:string, path: string) => `${basePath}/${path}`.replaceAll("//","/");

export const mapTabs = (basePath: string) => indexedMap((tab: TabItem, index:number) => ({...tab,path:createPath(basePath, tab.path),index}));

const indexedMap = addIndex<TabItem, TabItem>(map);
